<template>
  <section
    class="page flex flex-col items-center h-full relative"
    data-page-id="cover"
  >
    <div class="flex flex-col items-center justify-between w-full">
      <div class="flex flex-col items-center my-40">
        <AppImgPlaceholder
          :src="pdfData.logo"
          class="!h-[75mm] mb-10"
        />

        <h1 class="text-[50pt] font-semibold text-black mb-4">
          DDM One Plan
        </h1>

        <h4>District: {{ pdfData.district.name }}</h4>
        <h4>Last Published: {{ formatShortDateAndTime(pdfData.lastPublishedAt) }}</h4>
      </div>

      <div class="w-full flex items-center justify-between [&>div]:h-[160px]">
        <AppImgPlaceholder :src="pdfData.coatOfArms" />

        <AppImgPlaceholder :src="pdfData.provincialLogo" />

        <AppImgPlaceholder :src="pdfData.saDDM" />
      </div>

      <div class="absolute bottom-0 left-0 w-full flex h-[3mm]">
        <div
          v-for="color in ['bg-black', 'bg-green-700', 'bg-orange-700', 'bg-blue-700', 'bg-yellow-400']"
          :key="color"
          :class="color"
          class="h-full flex-1"
        />
      </div>
    </div>

    <!--static reuseable elements-->
    <div class="!h-0 overflow-hidden hidden">
      <div class="header-left h-full !flex items-end">
        <div class="flex gap-3 h-[20mm]">
          <img
            :src="pdfData.coatOfArms"
            class="h-full w-fit object-contain"
          >

          <img
            :src="pdfData.provincialLogo"
            class="h-full w-fit object-contain"
          >
        </div>
      </div>

      <div class="header-right h-full !flex items-end justify-end">
        <div class="flex gap-5 h-[20mm]">
          <img
            :src="pdfData.logo"
            class="h-full w-fit object-contain"
          >

          <img
            :src="pdfData.saDDM"
            class="h-full w-fit object-contain"
          >
        </div>
      </div>

      <div class="footer h-full">
        <div class="flex items-center justify-between border-t pt-1 pb-8 border-black w-full relative top-full -translate-y-full">
          <span class="footer-left font-semibold text-black text-[13px] whitespace-prewrap inline-block h-fit tracking-tight">{{ pdfData.district.name }} DDM One Plan&nbsp;&nbsp;|&nbsp;&nbsp;</span>

          <div class="footer-right !flex items-center text-end">
            <img
              :src="pdfData.livingPlansLogoText"
              class="h-[22px]"
            >
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { AppImgPlaceholder } from '@/components/app';
import { useDateFormatter } from '@/composables';

const { formatShortDateAndTime } = useDateFormatter();

const props = defineProps({
  pdfData: {
    type: Object,
    required: true,
  },
});
</script>
